import { action, makeObservable, observable } from 'mobx';

import InvoiceDetailsStore from '../InvoiceDetailsStore';

export default class InvoiceDetailsContentViewStore {
  @observable public showLargeInvoice = false;

  constructor(private invoiceDetailsStore: InvoiceDetailsStore) {
    makeObservable(this);
  }

  @action
  public setShowLargeInvoice(showLargeInvoice: boolean): void {
    this.showLargeInvoice = showLargeInvoice;
  }

  public shouldShowInvoiceDetails(): boolean {
    const { invoiceDetails } = this.invoiceDetailsStore;

    return invoiceDetails.payload.status !== 'TOO_LARGE' || (invoiceDetails.payload.status === 'TOO_LARGE' && this.showLargeInvoice);
  }
}
